import { useState } from "react";
import { Outlet } from "react-router-dom";
import AdminV2Sidebar from "./AdminV2Sidebar";
import "../admin-v2.css";

export default function AdminV2Layout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="admin-v2-shell">
      <div className="lg:tw-hidden">
        <AdminV2Sidebar />
        <main className="admin-v2-app-fluid tw-px-0 tw-pb-6 tw-pt-4">
          <Outlet />
        </main>
      </div>

      <div className="admin-v2-desktop-frame tw-hidden lg:tw-flex">
        <AdminV2Sidebar collapsed={collapsed} onToggleCollapse={() => setCollapsed((value) => !value)} />
        <main
          className={`admin-v2-content-scroll admin-v2-desktop-content tw-flex-1 ${
            collapsed ? "admin-v2-desktop-content-collapsed" : ""
          }`}
        >
          <div className="admin-v2-app-fluid">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
